{
  "version": 1,
  "asset_id": "636dead3-043d-4fa2-b850-0cb982ff70d6",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/636dead3-043d-4fa2-b850-0cb982ff70d6/clip-img_2293.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/636dead3-043d-4fa2-b850-0cb982ff70d6/clip-img_2293.mp4",
  "original_filename": "clip-img_2293.mp4",
  "size": 231467,
  "content_type": "video/mp4",
  "created_at": "2026-08-01T22:33:03Z"
}
